import {CourseMediaAssetsContext, CourseMediaAssets} from '../../../components/courses/CourseMediaAssetsContext';
import {CourseProviderProps} from '../../../context/course.type';
import * as React from 'react';

import {CourseProvider} from '../../../context/CourseContext';
import {CourseModulesBaseComponent} from '../../../components/courses/CourseModulesBaseComponent';

interface CourseProps {
  id: number|string;
  title: string;
  description: string;
}

const CourseForm = ({course, programs, courseCategories, mediaAssets = {}}: Omit<CourseProviderProps, 'children'> & {mediaAssets?: CourseMediaAssets}) => {
  document.title = `${window.account}/info-produtos`;
  return (
    <CourseProvider course={course} programs={programs} courseCategories={courseCategories}>
      <CourseMediaAssetsContext.Provider value={mediaAssets}><CourseModulesBaseComponent /></CourseMediaAssetsContext.Provider>
    </CourseProvider>
  )
}

export default CourseForm;